import { render, staticRenderFns } from "./DownInstructions.vue?vue&type=template&id=7528e22e&"
import script from "./DownInstructions.vue?vue&type=script&lang=js&"
export * from "./DownInstructions.vue?vue&type=script&lang=js&"
import style0 from "./DownInstructions.vue?vue&type=style&index=0&id=7528e22e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports